<template>
    <div class="time-filter">
        <div v-for="option in filter.inputs.mode.options" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="`mode${option.value}`">
                    <input
                        :id="`mode${option.value}`"
                        v-model="mode"
                        type="radio"
                        :value="option.value"
                    />
                    {{ option.label }}
                </label>
            </div>
            <div v-if="mode === option.value" class="form-group form-group-32">
                <el-time-picker
                    v-if="option.value !== 'between'"
                    :ref="reference"
                    v-model="value"
                    :placeholder="$t.__('common.labels.hour')"
                    valueFormat="HH:mm"
                    format="HH:mm"
                />
                <el-time-picker
                    v-if="option.value === 'between'"
                    :ref="reference"
                    v-model="timerange"
                    :placeholder="$t.__('common.labels.hour')"
                    valueFormat="HH:mm"
                    format="HH:mm"
                    :isRange="true"
                    class="time-filter__timepicker"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],

    data() {
        return {
            mode: '',
            value: '00:00',
            start: '00:00',
            end: '23:59',
            timerange: ['00:00', '23:59'],
        };
    },

    computed: {
        data() {
            return {
                mode: this.mode,
                value: this.value,
                start: this.timerange[0],
                end: this.timerange[1],
            };
        },
    },

    watch: {
        timerange(newval) {
            if (newval != null) {
                this.start = newval[0];
                this.end = newval[1];
            } else {
                this.start = '00:00';
                this.end = '23:59';
            }
        },
    },

    created() {
        if (this.mode == 'between' && this.start && this.end) {
            this.timerange = [this.start, this.end];
        }
    },
};
</script>
<style lang="scss">
.time-filter {
    .time-filter__timepicker {
        .el-range__icon {
            line-height: initial;
        }
        .el-range__close-icon {
            line-height: initial;
        }
        .el-range-separator {
            height: auto;
        }
    }
}
</style>